import { BookingEvent } from '@deltager/organizers/admin/shared/models/booking-event.model';
import {
  BookingEventSetupWizardStep,
} from '@deltager/organizers/admin/modules/booking-event-setup/pages/main/components/wizard/booking-event-setup-wizard-step.enum';

export enum BookingEventSetupStatus {
  Initializing = 1,
  Initialized = 2,
  Creating = 3,
  Created = 4,
  Updating = 5,
  Updated = 6,
  Modified = 7,
  Published = 8,
}

export interface BookingEventSetupState {
  initialEvent?: BookingEvent;
  bookingEvent?: BookingEvent;
  bookingEventSetupStatus: BookingEventSetupStatus;
  currentStep: BookingEventSetupWizardStep;
  automaticPublish?: boolean;
}

export const INITIAL_BOOKING_EVENT_SETUP_STATE: BookingEventSetupState = {
  initialEvent: null,
  bookingEvent: null,
  bookingEventSetupStatus: BookingEventSetupStatus.Initializing,
  currentStep: BookingEventSetupWizardStep.Details,
};
